/**
 * Canonical auth-token source for every authenticated request (feat-026).
 *
 * Prior to this, a broad surface read only the legacy `localStorage 'token'`
 * key, which is null for Cognito-logged-in users (Google login is dead). Those
 * requests sent `Bearer null`; once feat-023 deployed real JWT verification to
 * the backend, they started returning 401. This helper is the ONE place a
 * bearer token is sourced: prefer the Cognito access token, fall back to the
 * legacy `'token'` key for any not-yet-migrated path (kept for safety).
 */

/** Cognito access token if present, else the legacy `'token'`, else null. */
export const getAuthToken = (): string | null =>
  localStorage.getItem('cognito_access_token') || localStorage.getItem('token');

/**
 * Authorization header for an authed request. Returns an empty object when no
 * token exists so callers never emit `Bearer null`.
 */
export const authHeader = (): Record<string, string> => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
